<template>
  <div>
    <p class="very-small">{{ info }}</p>
  </div>
</template>

<script>
// import {
//   mapState,
//   mapGetters
// } from 'vuex'
// import l from '@/vendor/logger'
import now from '@/mixins/now'
import * as _ from 'ramda'

export default {
  name: 'MediaStatus',

  mixins: [now],

  props: [
    'media'
  ],

  data () {
    return {
    }
  },

  computed: {
    info () {
      return this.media && this.media.id
        ? this.media.getTracks()
          .map((track) => {
            return {
              kind: track.kind,
              label: track.label,
              enabled: track.enabled,
              readyState: track.readyState,
              constraints: {
                ..._.omit(['deviceId'], track.getConstraints())
              },
              settings: {
                ..._.omit(['deviceId', 'groupId'], track.getSettings())
              }
            }
          })
        : ''
    }
  }
}
</script>

<style scoped>
.very-small {
  font-size: .5em
}
</style>
